import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';

export const SideBarCardExpandAnimation = trigger('expand', [
  state('close', style({height: '0px', overflow: 'hidden'})),
  state('open', style({ height: '*',overflow: 'hidden'})),
  transition('open <=> close', animate('150ms ease-out')),
]);

@Component({
  selector: 'app-sidebar-card',
  templateUrl: './sidebar-card.component.html',
  styleUrls: ['./sidebar-card.component.scss']
})
export class SidebarCardComponent {

}
